import { render } from "./OddsMatchContentDetail.vue?vue&type=template&id=42697c27"
import script from "./OddsMatchContentDetail.vue?vue&type=script&lang=js"
export * from "./OddsMatchContentDetail.vue?vue&type=script&lang=js"

import "./OddsMatchContentDetail.vue?vue&type=style&index=0&id=42697c27&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__